import CareIcon from './CareIcon'

export default CareIcon
